import {JobUserMentionNotificationDataApiDto} from "../../../api/model/rest";

/**
 * Job user mention notification class data.
 */
export default class JobUserMentionNotificationData {
	/**
	 * @param {string} jobId Job identifier.
	 * @param {string} referenceNumber Job reference number.
	 */
	constructor(public readonly jobId: string,
		public readonly referenceNumber: string) {}

	static fromJson(json: JobUserMentionNotificationDataApiDto): JobUserMentionNotificationData {
		return new JobUserMentionNotificationData(json.jobId, json.referenceNumber);
	}
}